
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/options/[slug]",
      function () {
        return require("private-next-pages/options/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/options/[slug]"])
      });
    }
  